import {Selector, useDispatch, useSelector} from "react-redux";
import {ActionCreator} from "redux";

import {IAppError, RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../app/rp_reducer";

export interface IForm<T> {
    formValues: T;
    request: RequestState;
    errors: IAppError | null;
}

// TODO: after rebranding - find a better place for this hook (probably belongs to login domain)
export const useForm = <T>(selectorFn: Selector<IRPStore, IForm<T>>, updateFormFn: ActionCreator<{type: string; formValues: Partial<T>}>) => {
    const formData = useSelector(selectorFn);
    const dispatch = useDispatch();
    const onChange = (formValues: Partial<T>) => dispatch(updateFormFn(formValues));

    return {
        formData,
        onChange
    };
};
